import { CSSProperties } from 'react';

import { AppColors } from '../../theme';

type DateRangeStyles = {
  presetOption: CSSProperties;
  presetOptionHover: CSSProperties;
};

const styles: DateRangeStyles = {
  presetOption: {
    borderRadius: '12px',
    textAlign: 'left',
    display: 'block',
    margin: 'auto',
    width: '100%',
    whiteSpace: 'nowrap',
    wordBreak: 'break-word',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  presetOptionHover: {
    backgroundColor: AppColors.VA.NEUTRALS._30_,
    borderRadius: '999px',
    color: AppColors.VA.PRIMARY._50_
  }
};

export default styles;
